<template>
  <!-- WhatsApp contact button -->
  <button id="button" class="whatsapp-btn" @click="$refs.captcha.open()" aria-label="Contact via WhatsApp">
    <i class="fa-brands fa-whatsapp text-white"></i>
  </button>

  <!-- WhatsApp captcha modal -->
  <WhatsAppCaptcha ref="captcha" />

  <!-- Header component -->
  <Header />

  <!-- Main content -->
  <router-view />

  <!-- Footer component -->
  <Footer />

  <!-- Preloader component -->
  <Preloader />
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import Preloader from './components/Preloader.vue'
import WhatsAppCaptcha from './components/WhatsAppCaptcha.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    Preloader,
    WhatsAppCaptcha,
  },
  mounted() {
    // Assegurar que el botó de WhatsApp es comporta correctament
    // Aquest codi es dispararà després que Vue munti el component, però abans que jQuery prengui el control
    const whatsappBtn = document.getElementById('button');
    if (whatsappBtn) {
      whatsappBtn.classList.remove('show');
    }
  }
}
</script>

<style scoped>
.whatsapp-btn {
  font-size: 24px;
  line-height: 24px;
  color: #fff;
  background-color: #25D366;
  position: fixed;
  right: 30px;
  bottom: 30px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  z-index: 999;
  opacity: 0;
  visibility: hidden;
  transform: translateY(20px);
  pointer-events: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.whatsapp-btn.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
  pointer-events: auto;
  /* Habilitem la interacció quan és visible */
}

.whatsapp-btn:hover {
  background-color: #128C7E;
  transform: translateY(-3px);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
}

#button::after {
  content: "";
}
</style>
